import { TranslationsContext, useIsMobileHook } from '@telia-common-components/shared';
import * as React from 'react';
import { Button, Grid, GridColumn, Heading, Icon, Notice, Separator, Text } from 'telia-front-react';
import { formatPrice } from '../../../../util/PriceUtil';
import { useInternetCalculator } from '../InternetCalculatorProvider';
import { formatPlanDueDate, is5gTechnology, isPlanDueDateInPast } from '../util/InternetOfferUtil';
export const PlannedInternetDescription = (props) => {
    const { offer } = props;
    const { internetCalculatorConfigState, setModalState } = useInternetCalculator();
    const { translate } = React.useContext(TranslationsContext);
    const { isMobile } = useIsMobileHook();
    const is5G = is5gTechnology(offer.technology);
    const formattedDate = formatPlanDueDate(offer);
    const inPast = isPlanDueDateInPast(offer);
    if (!internetCalculatorConfigState.config) {
        return null;
    }
    const plannedNetworks = is5G ? internetCalculatorConfigState.config.future5gInternets : internetCalculatorConfigState.config.futureCableInternets;
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading, { level: 2, className: "h4 text-bold" }, translate('internetCalculator.details.plannedNetwork.title')),
        React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
        React.createElement(Notice, null,
            React.createElement(Text, null,
                React.createElement("p", null,
                    React.createElement("strong", null, offer.planDueDate
                        ? translate(`internetCalculator.details.plannedNetwork${is5G ? '5g' : ''}.${inPast ? 'descriptionWithPastDate' : 'descriptionWithDate'}`, {
                            date: formattedDate,
                        })
                        : translate(`internetCalculator.details.plannedNetwork${is5G ? '5g' : ''}.description`))),
                !is5G && (React.createElement("p", null,
                    translate('internetCalculator.details.plannedNetwork.description2.prefix'),
                    React.createElement(Button, { link: true, isUnderlined: true, text: translate('internetCalculator.details.plannedNetwork.description2.button'), onClick: () => setModalState({ offer, showForm: true }) }),
                    translate('internetCalculator.details.plannedNetwork.description2.suffix'))))),
        React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
        React.createElement(Heading, { level: 2, className: "h4 text-bold" }, translate('internetCalculator.details.plannedNetwork.plannedSpeeds')),
        React.createElement(Separator, { color: "invisible", spacing: "xsmall" }),
        plannedNetworks.map((futureInternet, index) => (React.createElement(React.Fragment, { key: `future-internet-${index}` },
            index === 0 && React.createElement(Separator, { spacing: "xxsmall", weight: "thin" }),
            React.createElement(Grid, null,
                React.createElement(GridColumn, { width: ['xs-8', 'sm-7'], align: ['middle-xs'], className: "text-left" },
                    React.createElement(Grid, { horizontalGutter: "smedium", verticalGutter: "none", noWrap: true, gutter: "small" },
                        !isMobile && (React.createElement(GridColumn, { width: ['min-xs'], align: ['middle-xs'] },
                            React.createElement(Icon, { modifiers: "#arrow-up-down", size: "sm" }))),
                        React.createElement(GridColumn, { width: ['max-xs'], align: ['middle-xs'] }, translate('internetCalculator.details.futureNetSpeed', {
                            speed: `${futureInternet.up}/${futureInternet.down}`,
                        })))),
                React.createElement(GridColumn, { width: ['xs-4', 'sm-5'], align: ['middle-xs'], className: "text-right" },
                    React.createElement("strong", null,
                        formatPrice(futureInternet.price),
                        translate('internetCalculator.price.permonth')))),
            React.createElement(Separator, { spacing: "xxsmall", weight: "thin" }))))));
};
